export const FETCH_COMPONENT_SETTING = "FETCH_COMPONENT_SETTING";
export const FETCH_MENU_COMPONENT_SETTING_SUCCESS = "FETCH_MENU_COMPONENT_SETTING_SUCCESS";
